import React, { useEffect, useState } from "react";
import { postData } from "../axios/axiosHelper";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

const ForgetPasswordHook = () => {
  const navigate = useNavigate();
 
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    email: "",

  });
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

 

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setLoading(true);
    await postData("/admin/auth/forgotPassword", formData)
      .then((response) => {
      
          toast.success(response?.data?.message);
          navigate("/login");
        
      })
      .catch((err) => toast.error(err?.response?.data?.message))
      .finally((_) => setLoading(false));
  };
  return {
  
    formData,
    setFormData,
    loading,
    handleForgotPassword,
    handleInputChange,
  };
};

export default ForgetPasswordHook;
